$(document).ready(function(){
  "Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

  window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
    subscribe('appLoad', function(event) {
      Shoppad.$('.spb-productoptionswatchwrapper').contents().filter(function() {
        return this.nodeType == 3;
      }).wrap('<span class="spb-swatchtooltip"></span>');
    });
  };

  
setTimeout(function() {
  $('#infiniteoptions-container div.option > span').after('<div class="btns infinite_options"><span class="prev-btn" >Prev</span> <span class="next-btn disabled">Next</span></div>'); 
}, 5000); 



// second textarea messageCard, second textarea instructions
$(document).on('keyup', '.option.messageCard textarea', function() {
    var messageCardValue = $('.option.messageCard textarea').val();
    // var textareaValue = $('.option.instructions textarea').val();


  if (messageCardValue.length > 0) {
    $('.option .next-btn').removeClass('disabled');
    
    // $(document).find('.product__actions button.button').text("Finish Purchase");
    $(document).find('.product__actions button.button').css({ "cursor": "pointer", "pointer-events": "auto" });
    
    // $(document).find('.option.messageCard, .option.instructions').addClass('checked-box');

  }
  else {
    $('.option.instructions .next-btn').addClass('disabled');
    // $(document).find('.product__actions button.button').text("Select Options");
    $(document).find('.product__actions button.button').css({ "cursor": "no-drop", "pointer-events": "none" });
    // $(document).find('.option.messageCard, .option.instructions').removeClass('checked-box');
  }
});

$(document).on('change', '.option input', function() {


  if ($(this).is(':checked')) {
    $('.option .btns.infinite_options .next-btn').removeClass('disabled');
    
    // $(document).find('.product__actions button.button').text("Finish Purchase");
    $(document).find('.product__actions button.button').css({ "cursor": "pointer", "pointer-events": "auto" });
    
    // $(document).find('.option.messageCard, .option.instructions').addClass('checked-box');

  }
  else {
    $('.option .btns.infinite_options .next-btn').addClass('disabled');
    // $(document).find('.product__actions button.button').text("Select Options");
    $(document).find('.product__actions button.button').css({ "cursor": "no-drop", "pointer-events": "none" });
    // $(document).find('.option.messageCard, .option.instructions').removeClass('checked-box');
  }
});

var optLen = 0;
var curLen = 0;
setTimeout(function () {

optLen = $('#infiniteoptions-container .option').length;
console.log(optLen + 'llllokkk')
  
}, 5000);

  
$(document).on('click','#infiniteoptions-container .option .btns.infinite_options .next-btn', function () {

  $(this).parents('.option').css('display','none').addClass('complete');
  $(this).parents('.option').next().css('display','block').addClass('complete');
  
    $('html, body').animate({
      scrollTop: $('#infiniteoptions-container').offset().top,
    });
  setTimeout(function () {
      curLen = $('#infiniteoptions-container .option.complete').length;
      console.log(curLen + '---current len')
      
      if(optLen === curLen){
        // $(document).find('.cstm-product .product__actions button.button').text("Finish Purchase");
        console.log('Finish Purchase')
      }
      else{
        // $(document).find('.cstm-product .product__actions.ramo button.button').text("Select Options");
      }
   }, 500);
  
});
$(document).on('click','#infiniteoptions-container .option .btns.infinite_options .prev-btn', function () {

  $(this).parents('.option').css('display','none').removeClass('complete');
  $(this).parents('.option').prev().css('display','block');

  $('html, body').animate({
    scrollTop: $('#infiniteoptions-container').offset().top,
  });
  
  setTimeout(function () {
      curLen = $('#infiniteoptions-container .option.complete').length;
      console.log(curLen + '---current len')
      
      if(optLen === curLen){
        // $(document).find('.cstm-product .product__actions button.button').text("Finish Purchase");
        console.log('Finish Purchase')
      }
      else{
        // $(document).find('.cstm-product .product__actions.ramo button.button').text("Select Options");
      }
   }, 500);
  
  
});


// $(document).find('.cstm-product .product__actions button.button').text("Select Options");

  
// $(document).find('.cstm-product .product__actions.ramo button.button').text("Finish Purchase");






// terms and condition start
$(document).on('click', '.terms-condition input', function () {
  if($(this).prop('checked') == true){
      $(document).find('.cart-summary__content .cart-summary__error').hide();
      $('.terms-condition .errorCol').hide(); 
  }
  else{
      $(document).find('.cart-summary__content .cart-summary__error').hide();
  }
  
});  

$('body').on('click', '[name="checkout"]', function(event) {
  if ($('.terms-condition input').is(':checked')) {
      $(this).closest('form').submit();
      $('.terms-condition .errorCol').hide(); 
      $('span.overlay_btn').removeClass('active');
  } else {
      $('.required').show(); 
      $('.terms-condition .errorCol').show();
      event.preventDefault();
       $('span.overlay_btn').addClass('active');
  }
});

// terms and condition end


// app, hide today date js start 

// var currentDate = new Date();
// var day = ("0" + currentDate.getDate()).slice(-2);
// var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
// var year = currentDate.getFullYear();

// var todayDate = year + '-' + month + '-' + day;

// setTimeout(function () {
//     $('.ssdp__calendar tr td').each(function () {
//         var data = $(this).attr('data-date');
        
//         if (data === todayDate) {
//             console.log(data + "okkkk");
//             $(this).addClass('disabled');
//         }
//     });
// }, 2000);  


  
//app, hide today date js end

  

});  



$(document).on('change', '#terms', function(){
  if ($('.terms-condition input').is(':checked')) {
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: JSON.stringify({ 
        "attributes": { 
          "Terms and Condition": "Yes"
        }
      }),
      contentType: 'application/json',
      success: function(cart){
        // console.log(cart);
      },
      error: function(error){
        console.log(error);
      }
    });
  } else {
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: JSON.stringify({ 
        "attributes": { 
          "Terms and Condition": "No"
        }
      }),
      contentType: 'application/json',
      success: function(cart){
        // console.log(cart);
      },
      error: function(error){
        console.log(error);
      }
    });
  }
});